import {handleAuthFailure} from './authFailure';

const axios = require('axios').default;

/**
 * Global handling for responses that mean the session has ended. Registered once
 * from index.js. There is no retry here, so a failed token refresh cannot loop.
 */
axios.interceptors.response.use(
  (response)=> response,
  (error)=> {
    handleAuthFailure(error?.response?.data?.errorCode);
    return Promise.reject(error);
  }
);
